import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFieldType } from '../../models/frontend-field-type.enum';
import { Utils } from 'src/modules/utils/shared/utils';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { DatabaseUserGroupAttribute } from 'src/modules/database/shared/database-user-group-attribute.model';

@Component({
  selector: 'app-edit-general-user-group',
  templateUrl: './edit-general-user-group.component.html',
  styleUrl: './edit-general-user-group.component.scss'
})
export class EditGeneralUserGroupComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    item: DatabaseUserGroup;
    form: FrontendFormDefinition;
    
    async initParams(): Promise<boolean> {
        this.form = new FrontendFormDefinition([
            new FrontendFieldDefinition("name", "Name der Gruppe", FrontendFieldType.text),
            ...this.app.mainConfig.additionalUserGroupAttributes.map(a => {
                let result = Utils.cloneDeep(a);
                result.id = "attrib_" + result.id;
                return result;
            })
        ]);

        this.item = this.id == 0 ? new DatabaseUserGroup() : await this.app.loadDataHandler(async () => RestEndpoint.main().findById(this.id).run("api/app/userGroup").get(DatabaseUserGroup), this);

        this.form.fill(this.item);
        for (let attrib of this.app.mainConfig.additionalUserGroupAttributes) {
            let a = this.item.attributes.find(a2 => a2.key == attrib.id);
            if (a != null) {
                let field = this.form.getField("attrib_" + attrib.id);
                let v = field.type == FrontendFieldType.checkBox ? Utils.toBool(a.value) : a.value;
                field.setValue(v);
            }
        }
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: "Benutzergruppen", routerLink: ["/base2", "admin", "editGeneralUserGroups"] },
            { label: this.item.getStringRepresentation(), routerLink: ["/base2", "admin", "editGeneralUserGroup", this.id] }
        ]);
        return true;
    }

    async save(): Promise<void> {
        if (!this.app.validateForm(this.form)) {
            return;
        }

        this.form.get(this.item);

        for (let attrib of this.app.mainConfig.additionalUserGroupAttributes) {
            if (Utils.hasProperty(this.item, "attrib_" + attrib.id)) {
                let a = this.item.attributes.find(a2 => a2.key == attrib.id);
                if (a == null) {
                    a = Utils.fromPlain(DatabaseUserGroupAttribute, {
                        key: attrib.id
                    });
                    this.item.attributes.push(a);
                }
                a.value = this.item["attrib_" + attrib.id];
                delete this.item["attrib_" + attrib.id];
            }
        }

        if ((await this.app.saveDataHandler(async () => RestEndpoint.main().upsert(this.item).run("api/app/userGroup").getText(), this, true, true))[0]) {
            this.app.auth.updateUserDetails();
        }
    }

}
